import { Alert, Stack } from "@mui/material";
import { useTranslation } from "react-i18next";

export const Notes = () => {
  const { t } = useTranslation();

  return (
    <Stack>
      <Alert severity="info">{t("churches.profile.comingSoon")}</Alert>
    </Stack>
  );
};
